<template>
  <Footer class="layout-footer-center"></Footer>
</template>

<script>
export default {};
</script>

<style scoped></style>
